const PlaceHolder = () => {
  return <div style={{ width: 80, height: 80, background: '#555' }}></div>;
};

export default PlaceHolder;
